import { useId, useRef } from "react";
import { useLayoutWidth } from "@/hooks/use-layout-width";
import type { TimeAxisPanelSpec } from "../ChartSpec";
import { useSpec } from "../spec/spec-context";
import { Panel } from "./panel";

export function PanelStack({ resizable = true, baseHeightPx }: { resizable?: boolean; baseHeightPx?: number }) {
    const { spec } = useSpec();
    const stackRef = useRef<HTMLDivElement | null>(null);

    // We used to use `useElementDimensions`, but that measures getBoundingClientRect, which includes
    // the Dialog's scale-in transform — measured mid-animation, panels stuck 2% narrow.
    // contentRect ignores transforms.
    const stackWidth = useLayoutWidth(stackRef);

    // One width group for the stack, used only if a panel turns on gutter alignment.
    const groupId = useId();

    /* TODO: maybe some css styling to better handle multiple panels? */
    return (
        <div ref={stackRef} className={"flex flex-col gap-[16px] w-full"}>
            {spec.panels.map((panel) => (
                // TODO: Add guards for various panel types
                <Panel
                    key={panel.id}
                    spec={panel as TimeAxisPanelSpec}
                    groupId={groupId}
                    maxStackWidth={stackWidth}
                    resizable={resizable}
                    baseHeightPx={baseHeightPx}
                />
            ))}
        </div>
    );
}
